const divForgotPassword = {
  text: 'Link enviado para seu email',
  text1: 'Email enviado para'
};

export default divForgotPassword;
